import { StarIcon } from '@heroicons/react/24/outline'

import { dateToString, isDeviceTimezoneSpanish } from 'utils/date'
import AlertPending from './AlertPending'
import AlertPostponed from './AlertPostponed'
import HeadquarterChanged from './HeadquarterChanged'

const ResultsLeagues = ({
  matches,
  alwaysVS = false,
  showImg = true,
  setOnClick,
  torDetails,
  teamsImgs = {},
  pendingReview,
  postponedMatch
}) =>
  matches?.map((match, idx) => {
    const addLink =
      match?.IdResult ||
      match?.resultState === 'FCP-REVISADO' ||
      match?.resultState === 'CONFIRMADO'
    const isWO = match?.Obs?.includes('WO') || match?.Obs?.includes('W.O')
    return (
      <div key={idx}>
        {/* MOBILE */}
        <div
          className={`grid grid-cols-1 lg:hidden mb-6 ${
            addLink ? 'cursor-pointer' : ''
          }`}
          onClick={addLink ? setOnClick : null}
          data-daysid={match.MatchDaysId}
        >
          {idx > 0 && (
            <div className="border-t border-1 border-blue border-opacity-40 mb-5"></div>
          )}
          <div
            className={`flex py-4 rounded-t-md pl-6 items-center bg-${
              addLink && setOnClick ? torDetails?.color : 'sec-grey-3'
            }`}
          >
            <img
              className="h-5 w-5 object-cover mr-2"
              src="/assets/icon-clock.svg"
              alt=""
            />
            <p className="truncate font-alliance-medium text-blue">
              {match?.Date
                ? `${dateToString(match.Date).withYear}${
                    match.Schedule ? ` ${match.Schedule}` : ''
                  }`
                : match?.Schedule || '—'}
            </p>
            {pendingReview || match?.PendingReview ? (
              <div className="ml-4">
                <AlertPending />
              </div>
            ) : null}
            {postponedMatch || match?.PostponedMatch ? (
              <div className="ml-4">
                <AlertPostponed />
              </div>
            ) : null}
            {match?.HeadquarterChanged ? (
              <div className="ml-4">
                <HeadquarterChanged newName={match?.HeadquarterName} />
              </div>
            ) : null}
          </div>
          <div className="grid grid-cols-1 bg-sec-grey-4">
            <div
              key={match?.LocalTeamName || match?.Team1Name}
              className="relative flex items-center space-x-3 px-6 py-5 flex-1"
            >
              {showImg && (
                <div className="flex-shrink-0">
                  {match.LocalImage || teamsImgs.local ? (
                    <img
                      className="h-12 w-12 rounded-full object-cover object-top shadow-md"
                      src={match.LocalImage || teamsImgs.local}
                      alt=""
                    />
                  ) : (
                    <div className="flex h-12 w-12 items-center justify-center rounded-full bg-white">
                      <StarIcon className="h-8 w-8" />
                    </div>
                  )}
                </div>
              )}
              <div className="min-w-0 flex-1">
                <div href="#" className="focus:outline-none">
                  <span className="absolute inset-0" aria-hidden="true" />
                  <p className="text-[16px] font-bold text-blue">
                    {match?.LocalTeamName || match?.Team1Name}
                  </p>
                </div>
              </div>
            </div>
            <div className="flex justify-center items-center flex-1 col-span-2 bg-sec-grey-3 py-2">
              <p className="text-[18px] font-bold text-blue">
                {isWO
                  ? 'WO'
                  : alwaysVS
                  ? 'VS'
                  : match.Result || `${match.LocalPoints}-${match.AwayPoints}`}
              </p>
            </div>
            <div
              key={match?.AwayTeamName || match?.Team2Name}
              className="relative flex items-center space-x-3 px-6 py-5 flex-1"
            >
              {showImg && (
                <div className="flex-shrink-0">
                  {match.AwayImage || teamsImgs.away ? (
                    <img
                      className="h-12 w-12 rounded-full object-cover object-top shadow-md"
                      src={match.AwayImage || teamsImgs.away}
                      alt=""
                    />
                  ) : (
                    <div className="flex h-12 w-12 items-center justify-center rounded-full bg-white">
                      <StarIcon className="h-8 w-8" />
                    </div>
                  )}
                </div>
              )}
              <div className="min-w-0 flex-1">
                <div className="focus:outline-none">
                  <span className="absolute inset-0" aria-hidden="true" />
                  <p className="text-[16px] font-bold text-blue">
                    {match?.AwayTeamName || match?.Team2Name}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* LG */}
        <div className="hidden lg:flex">
          <div
            className={`flex-1 mx-2 border-blue border-opacity-40 pb-7 ${
              idx !== 0 ? 'border-t' : ''
            }`}
          >
            <div className="flex mt-8">
              <img
                className="h-5 w-5 mr-2"
                src="/assets/icon-clock.svg"
                alt=""
              />
              <p className="truncate text-sm text-blue">
                {match?.Date
                  ? `${dateToString(match.Date).withYear}${
                      match.Schedule ? ` ${match.Schedule}` : ''
                    }`
                  : match?.Schedule || '—'}
                {isDeviceTimezoneSpanish()}
              </p>
              {pendingReview || match?.PendingReview ? (
                <div className="ml-4">
                  <AlertPending extraClass="text-blue" />
                </div>
              ) : null}
              {postponedMatch || match?.PostponedMatch ? (
                <div className="ml-4">
                  <AlertPostponed />
                </div>
              ) : null}
              {match?.HeadquarterChanged ? (
                <div className="ml-4">
                  <HeadquarterChanged newName={match?.HeadquarterName} />
                </div>
              ) : null}
            </div>
            <div className="mt-5">
              <div
                className={`flex my-2 bg-sec-grey-4 min-h-[80px] transition-colors ${
                  addLink && setOnClick
                    ? `hover:cursor-pointer hover:bg-${
                        torDetails?.color || 'sec-grey-2'
                      }`
                    : 'hover:cursor-not-allowed'
                }`}
                onClick={addLink ? setOnClick : null}
                data-daysid={match.MatchDaysId}
              >
                <div
                  key={match?.LocalTeamName || match?.Team1Name}
                  className="relative flex items-center space-x-3 px-6 py-5 flex-1 pointer-events-none"
                >
                  <div className="flex-shrink-0">
                    {showImg &&
                      (match.LocalImage || teamsImgs.local ? (
                        <img
                          className="h-12 w-12 rounded-full object-cover object-top shadow-md"
                          src={match.LocalImage || teamsImgs.local}
                          alt=""
                        />
                      ) : (
                        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-white">
                          <StarIcon className="h-8 w-8" />
                        </div>
                      ))}
                  </div>
                  <div className="min-w-0 flex-1">
                    <div href="#" className="focus:outline-none">
                      <span className="absolute inset-0" aria-hidden="true" />
                      <p className="text-sm font-bold text-blue">
                        {match?.LocalTeamName || match?.Team1Name}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="flex justify-center items-center flex-1 pointer-events-none">
                  <p className="text-2xl font-bold text-blue">
                    {/* {match.played ? (isWO ? 'WO' : match.result) : 'VS'} */}
                    {isWO
                      ? 'WO'
                      : alwaysVS
                      ? 'VS'
                      : match.Result ||
                        `${match.LocalPoints}-${match.AwayPoints}`}
                  </p>
                </div>
                <div
                  key={match?.AwayTeamName || match?.Team2Name}
                  className="relative flex items-center space-x-3 px-6 py-5 flex-1 pointer-events-none"
                >
                  {showImg && (
                    <div className="flex-shrink-0">
                      {match.AwayImage || teamsImgs.away ? (
                        <img
                          className="h-12 w-12 rounded-full object-cover object-top shadow-md"
                          src={match.AwayImage || teamsImgs.away}
                          alt=""
                        />
                      ) : (
                        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-white">
                          <StarIcon className="h-8 w-8" />
                        </div>
                      )}
                    </div>
                  )}
                  <div className="min-w-0 flex-1 pointer-events-none">
                    <div href="#" className="focus:outline-none">
                      <span className="absolute inset-0" aria-hidden="true" />
                      <p className="text-sm font-bold text-blue">
                        {match?.AwayTeamName || match?.Team2Name}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  })

export default ResultsLeagues
